import React, { useEffect } from 'react';

import { Box, Button, Grid, Link, Typography } from '@material-ui/core';

import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import PolicyCard from '../../../../components/PolicySelection/PolicyCard.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../config/app';
import { useNavigationContext } from '../../../../context/Navigation/navigation.provider';
import { useTipification } from '../../../../hooks/useTipification';
import Products from './Products.component';
import usePayments from './hooks';

const Payments = (props) => {
  const {
    loading,
    loadingP,
    open,
    logAnalytics,
    setOpen,
    listProducts,
    filterProduct,
    finishSelection,
    setListProducts,
    policies,
    classes,
  } = usePayments();
  const { resetNavigationPayments } = useNavigationContext();
  const { trackEvent, events } = useTipification();

  useEffect(() => {
    resetNavigationPayments();
    trackEvent(events.ADVICE_PAYMENT_STATUS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box display={loading || loadingP ? 'block' : 'none'}>
        <Loader action={'Cargando pólizas'}></Loader>
      </Box>

      <SharedDialog
        open={open}
        content={
          <Box display="inline">
            <Typography display="block" variant="h6">
              Para conocer tu estado de cobranzas, podés hacerlo por nuestro
              Chat o Whatsapp al{' '}
              <Link
                href={appConfig?.WHATSAPP_LINK}
                rel="noopener"
                target="_blank"
              >
                <Box display="inline">
                  <Typography display="inline" color="secondary">
                    <div
                      style={{ display: 'contents' }}
                      onClick={() => logAnalytics()}
                    >
                      {appConfig?.FORMATED_WHATSAPP}
                    </div>
                  </Typography>
                </Box>
              </Link>
            </Typography>
          </Box>
        }
        onClose={() => setOpen(false)}
        actions={
          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      />

      {listProducts ? (
        <Products
          filterProduct={filterProduct}
          finishSelection={finishSelection}
        />
      ) : (
        <>
          <SubHeader
            content={
              <Box>
                <Typography variant="h6">
                  {' '}
                  ¿Qué póliza querés consultar?{' '}
                </Typography>
              </Box>
            }
            goBack={() => setListProducts(true)}
          ></SubHeader>

          <Grid container justify="center">
            <Grid item xs={11}>
              <Grid container>
                <Grid item xs={12}>
                  <Box my={2}>
                    <Typography>Pólizas</Typography>
                  </Box>
                </Grid>
                {policies?.length
                  ? policies.map((policy: any, index: number) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Box mx={1} my={1} className={classes.card}>
                          <PolicyCard
                            policy={policy}
                            navigate={'/account/payment/'}
                          />
                        </Box>
                      </Grid>
                    ))
                  : 'No tenés pólizas para los ramos seleccionados'}
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default Payments;
